<template>
  <div class='TopUpQuery'>
    <Tab :Tab="Tab"></Tab>
    <search-form size='medium'
                 labelWidth='90px'
                 class="SearchForm"
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:issuingType="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, item.issuingType) }}</span>
      </template>
      <template v-slot:Paging>
        <Paging @change="searchHandleForm"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Tab from '@/components/Tab.vue'
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
const typeProps = { label: 'name', value: 'id' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Tab,
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      Tab: {
        select: '0',
        pages: [
          {
            name: '已充值',
            id: '0'
          },
          {
            name: '充值记录',
            id: '1'
          }
        ],
        handle: () => this.cutPages()
      },

      search: { // 搜索
        searchData: {
          interst: []
        }, // 返回的数据
        searchForm: [

        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },
      cardNatureObj:{
        0: '定额卡',
        1: '不定额卡',
        2: '动态充值卡'
      },
      stateObj:{
        0:'待处理',
        1:'通过',
        2:'驳回'
      },
      Table: { // 表格
        data: [{
          a: '系统自动生成',
          b: '显示卡名称',
          c: 'A类',
          d: '100',
          e: '1',
          f: '2019.12.12 ~ 2020.12.12'
        }],
        TabColumn: [
          [
            { prop: 'cardNo', label: '账号' },
            { prop: 'cardTypeName', label: '账户类型' },
            { prop: 'issuingType', label: '发行方式', slot: true },
            { prop: 'denomination', label: '合计充值金额' },
            { prop: 'bindAccount', label: '会员ID' },
            { prop: 'bindAccountName', label: '账号名称' },
            { prop: 'rechargedTime', label: '充值日期' },
          ],
          [
            { prop: 'cardNo', label: '账号' },
            { prop: 'cardTypeName', label: '账户类型' },
            { prop: 'rechargeAmount', label: '充值金额' },
            { prop: 'settleAmount', label: '实际支付金额' },
            { prop: 'bindAccount', label: '会员ID' },
            { prop: 'bindAccountName', label: '账号名称' },
            { prop: 'createTime', label: '充值日期' },
            { prop: 'statusName', label: '审核状态' },
          ]
        ],
        column: []

      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {

  },
  // 方法集合
  methods: {
    exportFn(e){
      const params = this.handleParams()
      params.pageNum = null 
      params.pageSize = null
      this.$http.rechargeistExport(params).then((res) => {
          if (res.status === 200) {
            this.$message.success('执行成功')
          }else{
            this.$message.error(res.msg)
          }
        })

    },
    cutPages (tab, event) { // 切换tab
      const { Table, Tab } = this
      
      if(Tab.select === '0'){
        this.search.searchForm = [
                     { type: 'Input', label: '账号：', prop: 'cardNo', placeholder: '请输入账号' },
          { type: 'Select', label: '账户类型：', prop: 'cardTypeId', width: '180px', options: this.cardTypeList, props: typeProps, change: row => '', placeholder: '请选择账户类型' },
        { type: 'InputRange', label: '充值次数：', prop: 'startCount', prop1: 'endCount', placeholder: '' },
        { type: 'Input', label: '会员ID：', prop: 'bindAccount', placeholder: '请输入会员ID' },
        { type: 'Input', label: '账号名称：', prop: 'bindAccountName', placeholder: '请输入账号名称' },
        ]
        this.Table.defaultBtn = null
      }
      if(Tab.select === '1'){
        this.search.searchForm = [
                     { type: 'Input', label: '账号：', prop: 'cardNo', placeholder: '请输入账号' },
          { type: 'Select', label: '账户类型：', prop: 'cardTypeId', width: '180px', options: this.cardTypeList, props: typeProps, change: row => '', placeholder: '请选择账户类型' },
        { type: 'Input', label: '会员ID：', prop: 'bindAccount', placeholder: '请输入会员ID' },
        { type: 'Input', label: '账号名称：', prop: 'bindAccountName', placeholder: '请输入账号名称' },
        { type: 'Select', label: '审核状态：', prop: 'status', options: [
          {name:'待处理',id:0},
          {name:'通过',id:1},
          {name:'驳回',id:2}
        ], props: typeProps, change: row => '', placeholder: '请选择审核状态' },
        { type: 'daterange', label: '充值日期：', prop: 'rechargeDate', span: 12 },
        ]
        this.Table.defaultBtn = {
          show: true,
          html: '导出',
          handle: (el) => this.exportFn(el)
        }
      }
      this.Table.column = Table.TabColumn[Tab.select]
      this.searchResetForm() // 调用重置
      this.pager.page = 1
      this.searchHandleForm()
    },

    searchHandleForm () { // 查询
      this.getItemList()
    },
    searchResetForm () { // 重置
      this.search.searchData = {}
    },

    handleParams () {
      const { pager, Tab } = this
      let search = null
      search = Object.assign(this.search.searchData, { recharged: true, determineValue: false, cardNature: 2 })
      if(Tab.select === '1'){
        // 动态充值记录查询的 cardNature :2 写死
        let rechargeDate = this.search.searchData.rechargeDate
        search = Object.assign(this.search.searchData, { cardNature: 2,rechargeDateBegin: rechargeDate? rechargeDate[0]:null, rechargeDateEnd: rechargeDate? rechargeDate[1]:null,})
      }
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search
      }
      if(Tab.select === '1'){
        params.rechargeDate = null
      }
      return params
    },

    getItemList () {
      const { Tab } = this
      const params = this.handleParams()
      if(Tab.select === '1'){
        this.$http.getDynamiCardList(params)
        .then((res) => {
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list.map((item) => ({
              ...item,
              bindAccount: (item.bindAccount || item.bindAccount === 'null') ? item.bindAccount : '-',
              cardNatureName: Tab.select === '1' ? this.cardNatureObj[2] : this.cardNatureObj[item.cardNature || 0],
              statusName: this.stateObj[item.status]
            }))
          }
        })
      }else{
        this.$http.getCardPagination(params)
        .then((res) => {
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list.map((item) => ({
              ...item,
              bindAccount: (item.bindAccount || item.bindAccount === 'null') ? item.bindAccount : '-',
              remaining: item.remaining ? item.remaining : '-',
              state: item.state.text,
              stateNo: item.state.value,
              validTime: `${item.validBegin} ~ ${item.validEnd}`,
              cardNatureName: this.cardNatureObj[item.cardNature || 0],
              denomination: item.denomination
            }))
          }
        })
      }
    },
    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            this.cardTypeList = res.data || []
          }
        })
    },
    // 初始化
    init () {
      this.getCardTypeList()
      const { Table } = this
      this.Table.column = Table.TabColumn[0]
      this.search.searchForm = [
           { type: 'Input', label: '账号：', prop: 'cardNo', placeholder: '请输入账号' },
          { type: 'Select', label: '账户类型：', prop: 'cardTypeId', width: '180px', options: this.cardTypeList, props: typeProps, change: row => '', placeholder: '请选择账户类型' },
        { type: 'InputRange', label: '充值次数：', prop: 'startCount', prop1: 'endCount', placeholder: '' },
        { type: 'Input', label: '会员ID：', prop: 'bindAccount', placeholder: '请输入会员ID' },
        { type: 'Input', label: '账号名称：', prop: 'bindAccountName', placeholder: '请输入账号名称' },
  
      ]
      this.getItemList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.SearchForm {
  margin-top: -50px;
}
</style>
